import React from 'react'
import { styles } from '../../styles'
import ComputerCanvas from './ComputerCanvasComponent'
import Magazines from '../../Magazines/Magazines'

const About = () => {
  return (
    <section className='relative w-full h-screen mx-auto hidden m560:block'>
      <div
        className={`${styles.paddingX} absolute inset-0 top-[120px] max-w-7xl mx-auto flex flex-row items-start gap-5`}
      >
        <section className='flex flex-col justify-center items-center mt-5'>
          <div className='w-5 h-5 rounded-full dark:bg-[#915eff] bg-white' />
          <div className='w-1 h-40 sm:h-80  rounded-full from-transparent dark:to-[#915eff] to-white bg-gradient-to-t' />
        </section>
        <section className=''>
          <h1 className='font-black dark:text-white text-primary lg:text-[80px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[98px] mt-2'>
            Hi, I'm{' '}
            <span className='text-[#915eff] text-4xl md:text-7xl '>
              Christsanctus.
            </span>
          </h1>
          <p className='sm:text-xl text-[14px] text-gray-500 tracking-wider mt-2 dark:text-white_100'>
            I develop 3D visuals, user <br className='sm:hidden block ' />{' '}
            interfaces, responsive web and mobile applications.
          </p>
        </section>
      </div>
      <ComputerCanvas />
    </section>
  )
}

export default Magazines(About, 'about')
